import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SupportService} from '../support.service';

interface SiteFile {
	name: string;
	folder: string;
	size: number;
	modified: string;
	path: string;
}

@Component({
	templateUrl: './site_files.component.html'
})
export class SiteFilesModalComponent {
	title: string;
	siteId: string;
	files: SiteFile[] = [];
	isLoading: boolean = true;
	deletingFile: string = null;
	comment: string = '';

	constructor(
		public activeModal: NgbActiveModal,
		public supportService: SupportService,
	) {}

	ngOnInit() {
		this.loadFiles();
	}

	loadFiles() {
		this.isLoading = true;

		this.supportService.getSiteFiles(this.siteId).subscribe(
			(data) => {
				this.files = (data.files || []).sort((a, b) => {
					return new Date(b.modified).getTime() - new Date(a.modified).getTime();
				});
				this.isLoading = false;
			},
			(err) => {
				console.error('getSiteFiles error', err);
				this.isLoading = false;
			}
		);
	}

	deleteFile(file: SiteFile) {
		if (!this.comment || this.comment.length < 10) {
			alert('Комментарий обязателен (минимум 10 символов)');
			return;
		}

		if (!confirm(`Удалить файл ${file.name} из папки ${file.folder}?`)) {
			return;
		}

		this.deletingFile = `${file.folder}/${file.name}`;

		this.supportService.deleteSiteFile(this.siteId, file.folder, file.name, this.comment).subscribe(
			() => {
				this.files = this.files.filter(f => !(f.folder === file.folder && f.name === file.name));
				this.deletingFile = null;
			},
			(err) => {
				console.error('deleteSiteFile error', err);
				alert('Ошибка удаления: ' + JSON.stringify(err));
				this.deletingFile = null;
			}
		);
	}

	formatFileSize(bytes: number): string {
		if (bytes === 0) return '0 B';
		const sizes = ['B', 'KB', 'MB', 'GB'];
		const i = Math.floor(Math.log(bytes) / Math.log(1024));
		return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
	}

	close() {
		this.activeModal.close('cancel');
	}
}
